<template>
  <div ref="buscadorOrlandoIndex" v-resize="configPlano">
    <v-card v-if="showBuscadorHtl" class="grey lighten-4" :img="app.bkBuscador">
      <v-card-text>
        <BuscadorHoteles :plano="plano" />
      </v-card-text>
    </v-card>
    <LoadingUtil v-if="!showBuscadorHtl" :config="{ cantidad: 1, width: 1317, height: 177 }" />

    <section></section>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapActions } from "vuex"
import { mapGetters } from "vuex"
import BuscadorHoteles from "@/components/hoteles/BuscadorHoteles.vue"
import moment from "moment"
import AxiosHandler from "@/assets/js/class/AxiosHandler.js"
import LoadingUtil from "@/components/hoteles/LoadingUtil.vue"

export default {
  name: "indexOrlando",
  components: {
    BuscadorHoteles,
    LoadingUtil
  },
  mounted() {
    this.configPlano()
  },
  beforeCreate() {},
  methods: {
    ...mapActions("carrito", {
      limpiarCarrito: "limpiar"
    }),
    init() {
      this.limpiarCarrito()
      this.setApp()
      this.prepararFormulario()
      this.$store.dispatch("app/setFormSave", null)
      this.$store.dispatch("app/setFormSaveTicket", null)
    },
    setApp() {
      this.$store.dispatch("app/saveApp", this.$route.meta.app)
    },
    async prepararFormulario() {
      this.showBuscadorHtl = false
      this.prepararDisney()
      await this.$store.dispatch("app/saveFormConfigHtl", JSON.parse(JSON.stringify(this.formConfig)))
      this.showBuscadorHtl = true
    },
    async getDestinos() {
      var header = this.$passporthandler.prepareHeader()
      if (!(typeof header.auth === "undefined")) {
        return this.$router.replace({ name: "login" })
      }
      let handler = new AxiosHandler()
      handler.setPassportHandler(this.$passporthandler)
      const url = `${process.env.VUE_APP_ASBACK}/api/get-destinos-buscador/${this.app.cliente_id}`
      handler.prepare(url, header)
      handler.overlay(false)
      await handler.exe()
      var promise1 = Promise.resolve(handler.getData().destinos)
      return promise1.then(function(value) {
        return value
      })
    },
    configPlano() {
      if (this.$refs.buscadorOrlandoIndex == undefined) {
        return
      }
      let width = this.$refs.buscadorOrlandoIndex.clientWidth
      this.plano = "row"
      if (width <= 400 && width != 0) {
        this.plano = "column"
      }
    },
    prepararDisney() {
      this.formConfig.destinos = [
        /* 
       {
          value: "z-379936",
          text: "Walt Disney World",
          sufijo: "Estados Unidos",
          titulo: "Zonas",
          isDC: true
        },
        */
        {
          value: "z-223294",
          text: "Universal Studios",
          sufijo: "Estados Unidos",
          titulo: "Zonas",
          isDC: false
        }
      ]
      if (this.$route.name === "orlando" || this.$route.name === "universal") {
        return
      }
      this.formConfig.destinos = [
        {
          value: "z-379936",
          text: "Walt Disney World",
          sufijo: "Estados Unidos",
          titulo: "Zonas",
          isDC: true
        },
        {
          value: "z-223294",
          text: "Universal Studios",
          sufijo: "Estados Unidos",
          titulo: "Zonas",
          isDC: false
        }
      ]
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.init()
    })
  },
  data() {
    return {
      tabIndex: 0,
      showBuscadorHtl: false,
      formConfig: {
        categorias: [],
        ocupacion: [{ adultos: 2, edades: [] }],
        destinos: [
          {
            value: "z-379936",
            text: "Walt Disney World",
            sufijo: "Estados Unidos",
            titulo: "Zonas"
          },
          {
            value: "z-223294",
            text: "Universal Studios",
            sufijo: "Estados Unidos",
            titulo: "Zonas"
          }
        ],
        picker: {
          startDate: moment()
            .add(2, "days")
            .toDate(),
          endDate: moment()
            .add(730, "days")
            .toDate(),
          i18n: {
            night: "Noche",
            nights: "Noches",
            "day-names": moment.localeData("es").weekdaysMin(),
            "check-in": "Llegada",
            "check-out": "Salida",
            "month-names": moment.localeData("es").months()
          },
          minNoches: 1,
          maxNoches: 14
        },
        isDC: false
      },
      plano: "row"
    }
  },
  computed: {
    ...mapGetters("app", {
      app: "getApp"
    })
  }
}
</script>
<style scoped></style>
